import toast from "react-hot-toast";
import {BaseClient} from "../../Api/HttpClient";
import dayjs from "dayjs";
import {transformObjectToGetRequestParams} from "../../Utils/HttpHelper";

export const createAvailabilitySlice = (set, get) => ({
    availabilities: [],
    availabilitiesShifts: [],

    getAvailabilities: async (dateTimestamp = null, customer_id= null) => {
        await BaseClient().get('/availabilities?' + transformObjectToGetRequestParams({date:dateTimestamp, customer_id}))
            .then(response => {
                if (response.status === 200) {
                    set({availabilities: response.data})
                } else {
                    toast.error(response.data);
                }
            })
    },
    getAvailabilitiesAndShifts: async (date) => {
        await BaseClient().get(`/availabilities-shifts?` + transformObjectToGetRequestParams({date}))
            .then(response => {
                if (response.status === 200) {
                    set({availabilities: response.data.availabilities})
                    set({availabilitiesShifts: response.data.shifts})
                } else {
                    toast.error(response.data);
                }
            })
    },
    createAvailability: async (data) => {
        return await BaseClient().post('/availabilities', data)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    return response.data
                } else {
                    console.log(response)
                }
            }).catch(error => {
                console.log(error)
            })
    },
    updateAvailability: async (id, data) => {
        await BaseClient().post(`/availabilities/${id}`, data)
            .then(response => {
                if (response.status === 200) {
                    return response.data
                } else {
                    toast.error(response.data);
                }
            })
    },
    deleteAvailability: async (id) => {
        await BaseClient().delete(`/availabilities/${id}`)
            .then(response => {
                if (response.status === 200) {
                    return response.data
                } else {
                    toast.error(response.data);
                }
            })
    }
})